import React from "react";
import { Calendar, Clock, MapPin } from "lucide-react";

const AboutWelcomeEventAgenda = () => {
  return (
    <div className="py-2 px-4">
      {/* Header Kecil Tanpa Background */}
      <h4 className="text-left font-black text-slate-400 dark:text-slate-500 mb-10 uppercase tracking-[0.3em] text-[11px]">
        Event Details
      </h4>

      <div className="space-y-10">
        {/* Item 1: Date */}
        <div className="flex items-start gap-5 group">
          <div className="mt-1 text-slate-400 group-hover:text-blue-600 transition-colors duration-300">
            <Calendar size={22} strokeWidth={1.5} />
          </div>
          <div className="flex flex-col border-l border-slate-200 dark:border-slate-800 pl-5">
            <span className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1">
              Date
            </span>
            <span className="text-base font-black text-slate-700 dark:text-slate-300">
              Saturday, April 25th, 2026
            </span>
          </div>
        </div>

        {/* Item 2: Time */}
        <div className="flex items-start gap-5 group">
          <div className="mt-1 text-slate-400 group-hover:text-blue-600 transition-colors duration-300">
            <Clock size={22} strokeWidth={1.5} />
          </div>
          <div className="flex flex-col border-l border-slate-200 dark:border-slate-800 pl-5">
            <span className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1">
              Time
            </span>
            <span className="text-base font-black text-slate-700 dark:text-slate-300">
              08:00 - 18:00 WIB
            </span>
          </div>
        </div>

        {/* Item 3: Location */}
        <div className="flex items-start gap-5 group">
          <div className="mt-1 text-slate-400 group-hover:text-blue-600 transition-colors duration-300">
            <MapPin size={22} strokeWidth={1.5} />
          </div>
          <div className="flex flex-col border-l border-slate-200 dark:border-slate-800 pl-5">
            <span className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1">
              Venue
            </span>
            <span className="text-base font-black text-slate-700 dark:text-slate-300">
              Fairmont Hotel, Jakarta
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutWelcomeEventAgenda;